// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { UserListComponent } from './components/user-list/user-list.component';
import { UserEditComponent } from './components/user-edit/user-edit.component';

// Guards
import { RoleGuard } from '../../shared/guards/role.guard';
import { AuthGuard } from '../../shared/guards/auth.guard';
import { CanDeactivateGuard, EnvironmentGuard } from '../../shared/guards';

// Models
import { LayoutData } from '../../shared/models';

// Enums
import { Roles } from '../auth/models/roles.enum';
import { EnvironmentType } from '../../shared/enums/environment-type.enum';

const routes: Routes = [
	{
		path: '',
		component: UserListComponent,
		canActivate: [AuthGuard, RoleGuard, EnvironmentGuard],
		data: <LayoutData>{ roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin], permittedEnvironments: [EnvironmentType.PORTAL] },
	},
	{
		path: 'add',
		component: UserEditComponent,
		canActivate: [AuthGuard, RoleGuard, EnvironmentGuard],
		canDeactivate: [CanDeactivateGuard],
		data: <LayoutData>{ roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin], permittedEnvironments: [EnvironmentType.PORTAL] },
	},
	{
		path: 'edit/:id',
		component: UserEditComponent,
		canActivate: [AuthGuard, RoleGuard, EnvironmentGuard],
		canDeactivate: [CanDeactivateGuard],
		data: <LayoutData>{ roles: [Roles.TenantAdmin, Roles.SuperAdmin, Roles.Admin], permittedEnvironments: [EnvironmentType.PORTAL] },
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class UserRoutingModule {}
